<template>
  <v-container>
    <h1>Gestione Accessori</h1>
  </v-container>
</template>

<script>
  export default {
    name: 'GestioneAccessori'
  }
</script>

<style>
</style>
